module.exports = __webpack_public_path__ + "static/img/alarmlog.1e7f8663.png";